module.exports = __webpack_public_path__ + "img/23-1.961062ad.jpg";